<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="modal"
      centered
      @hidden="hide()"
      size="md"
      class="alert-modal"
      hide-header-close
      footer-class="pt-0 border-0"
    >
      <template #modal-header>
        <div class="modal-title">จัดการคลัง</div>
      </template>
      <div class="d-block">
        <b-tabs v-model="tabIndex" fill>
          <b-tab title="เพิ่ม" active class="pt-2">
            <InputSelect
              placeholder="คลัง"
              :validateText="`กรุณาเลือกคลัง`"
              title="คลัง"
              v-model="form.stock_type_id"
              :isValidate="$v.form.stock_type_id.$error"
              :v="$v.form.stock_type_id"
              valueField="id"
              @onDataChange="handleInventoryReceive($event)"
              textField="name"
              :options="listStock"
            >
              <template v-slot:option-first>
                <b-form-select-option :value="0" disabled
                  >-- เลือกคลัง --</b-form-select-option
                >
              </template>
            </InputSelect>
            <div v-if="form.is_serial">
              <b-row>
                <b-col cols="12">
                  <label class="main-label">Serial</label>
                </b-col>
              </b-row>
              <div class="px-3 maxheight-290px">
                <b-row
                  v-for="(item, index) in form.serial"
                  :key="`serial-received-${index}`"
                >
                  <b-col cols="1" class=""
                    ><div class="d-flex justify-content-center mt-3">
                      #{{ index + 1 }}
                    </div>
                  </b-col>
                  <b-col cols="10" class="p-0 mt-2">
                    <InputText
                      textFloat=""
                      placeholder="Serial"
                      :isValidate="$v.form.serial.$each[index].text.$error"
                      :v="$v.form.serial.$each[index].text"
                      v-model="item.text"
                    />
                  </b-col>
                  <b-col cols="1" class="">
                    <div
                      class="d-flex justify-content-center align-items-center mt-3"
                    >
                      <font-awesome-icon
                        icon="trash-alt"
                        title="delete-btn"
                        size="lg"
                        class="pointer text-primary icon-delete icon-size"
                        @click="deleteSerial(index)"
                      />
                    </div>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col cols="12">
                  <div
                    class="main-label text-link main-color mt-2"
                    @click="addSerial()"
                  >
                    Add New Serial
                  </div>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <InputText
                v-model="form.amount"
                textFloat="จำนวน"
                placeholder="จำนวน"
                @input="handleAmoutInput"
                type="number"
                name="transfer_amount"
                className="mb-2"
                isRequired
                :isValidate="$v.form.amount.$error"
                :v="$v.form.amount"
              />
            </div>
            <InputText
              v-model="form.available"
              textFloat="คงเหลือ"
              :textDesc="`จำนวนปัจจุบัน : ${form.stock}`"
              type="number"
              name="transfer_avilable"
              className="mb-2"
              disabled
            />

            <InputTextArea
              textFloat="หมายเหตุ"
              placeholder="หมายเหตุ"
              name="text"
              rows="5"
              v-model="form.note"
            />
          </b-tab>
          <b-tab title="ลด" class="pt-2">
            <InputSelect
              placeholder="คลัง"
              :validateText="`กรุณาเลือกคลัง`"
              title="คลัง"
              v-model="form.stock_type_id"
              :isValidate="$v.form.stock_type_id.$error"
              :v="$v.form.stock_type_id"
              valueField="id"
              @onDataChange="handleInventoryReceive($event)"
              textField="name"
              :options="listStock"
            >
              <template v-slot:option-first>
                <b-form-select-option :value="0" disabled
                  >-- เลือกคลัง --</b-form-select-option
                >
              </template>
            </InputSelect>
            <div v-if="form.is_serial">
              <b-row>
                <b-col cols="12">
                  <label class="">Serial</label>
                </b-col>
              </b-row>
              <div class="px-3 maxheight-290px">
                <b-row class="">
                  <b-col cols="12">
                    <b-input-group class="justify-content-end">
                      <b-form-input
                        textFloat=""
                        :disabled="!form.stock_type_id"
                        placeholder="Search Serial"
                        type="text"
                        v-model="searchSerial"
                        @input="handlesearchSerial"
                      >
                      </b-form-input>
                      <b-input-group-append is-text class="mr-2 h-35px">
                        <b-iconstack
                          font-scale="2"
                          type="submit"
                          @click="handlesearchSerial"
                          :disabled="!form.stock_type_id"
                        >
                          <b-icon
                            stacked
                            icon="search"
                            scale="0.5"
                            variant="grey"
                          ></b-icon>
                        </b-iconstack>
                      </b-input-group-append> </b-input-group
                  ></b-col>
                </b-row>
                <b-row
                  class="mt-2"
                  v-for="(item, index) in filteredSerial"
                  :key="`serial-damage-${index}`"
                >
                  <b-col cols="1" class=""
                    ><div class="d-flex justify-content-center mt-2">
                      #{{ index + 1 }}
                    </div>
                  </b-col>
                  <b-col cols="10" class="p-0">
                    <InputText
                      textFloat=""
                      :disabled="true"
                      placeholder="Serial"
                      type="text"
                      v-model="item.serial"
                    />
                  </b-col>
                  <b-col cols="1" class="">
                    <b-form-checkbox
                      class="pl-3 mt-2"
                      :id="item.serial"
                      name="damage"
                      :disabled="
                        !form.stock_type_id ||
                        mountingList.find(
                          (x) => x.serial === item.serial && !item.isMother
                        )
                          ? true
                          : false
                      "
                      :value="item.serial"
                      :checked="form.serial"
                      :unchecked-value="false"
                      @change="inputSerial(item.serial, 0, item)"
                    >
                    </b-form-checkbox>
                  </b-col>
                  <b-col cols="12" class="mb-2" v-if="item.isMother">
                    <b-row class="mx-2">
                      <b-col
                        cols="12"
                        v-for="(m, index_m) in item.mountingList.filter(
                          (x) => !x.isDupe
                        )"
                        :key="`mounting+${index_m}`"
                        class="f-12px mr-1 text-gray d-flex justify-content-between border-bottom border-left border-right"
                      >
                        <div class="ml-2 my-2">Serial: {{ m.serial }}</div>

                        <div class="mr-2 my-2">
                          Stock : {{ m.stock_type_name }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <div v-if="$v.form.serial.$error" class="text-error">
                  Please Select Serial
                </div>
              </div>
            </div>

            <InputText
              v-else
              v-model="form.amount"
              textFloat="จำนวน"
              placeholder="จำนวน"
              type="number"
              name="transfer_amount"
              @input="handleAmoutInput"
              className="mb-2"
              isRequired
              :isValidate="$v.form.amount.$error"
              :v="$v.form.amount"
            ></InputText>
            <InputText
              v-model="form.available"
              :textDesc="`จำนวนปัจจุบัน : ${form.stock}`"
              textFloat="คงเหลือ"
              type="number"
              name="transfer_avilable"
              className="mb-2"
              disabled />
            <InputTextArea
              textFloat="หมายเหตุ"
              placeholder="หมายเหตุ"
              name="text"
              rows="5"
              v-model="form.note"
          /></b-tab>
          <b-tab title="ปรับ" class="pt-2" v-if="!form.is_serial">
            <InputSelect
              placeholder="คลัง"
              :validateText="`กรุณาเลือกคลัง`"
              title="คลัง"
              v-model="form.stock_type_id"
              :isValidate="$v.form.stock_type_id.$error"
              :v="$v.form.stock_type_id"
              valueField="id"
              @onDataChange="handleInventoryReceive($event)"
              textField="name"
              :options="listStock"
            >
              <template v-slot:option-first>
                <b-form-select-option :value="0" disabled
                  >-- Select Stock --</b-form-select-option
                >
              </template>
            </InputSelect>
            <InputText
              v-model="form.amount"
              textFloat="จำนวน"
              placeholder="จำนวน"
              type="number"
              name="transfer_amount"
              className="mb-2"
              isRequired
              :textDesc="`จำนวนปัจจุบัน : ${form.stock}`"
              :isValidate="$v.form.amount.$error"
              :v="$v.form.amount"
              @onKeypress="isNumber($event)" />

            <InputTextArea
              textFloat="หมายเหตุ"
              placeholder="หมายเหตุ"
              name="text"
              rows="8"
              v-model="form.note"
          /></b-tab>
          <b-tab title="ย้าย">
            <div class="container-stock">
              <InputSelect
                placeholder="คลังต้นทาง"
                :validateText="`กรุณาเลือกคลัง`"
                title="คลังต้นทาง"
                v-model="form.inventory_from"
                :isValidate="$v.form.inventory_from.$error"
                :v="$v.form.inventory_from"
                @onDataChange="handleInventoryFrom($event, 0)"
                valueField="id"
                textField="name"
                class="mt-2"
                :options="listStock"
              >
                <template v-slot:option-first>
                  <b-form-select-option :value="0" disabled
                    >-- เลือกคลังต้นทาง --</b-form-select-option
                  >
                </template>
              </InputSelect>
              <div v-if="form.is_serial">
                <b-row>
                  <b-col cols="12">
                    <label class="main-label">Serial</label>
                  </b-col>
                </b-row>
                <div class="px-3 maxheight-290px">
                  <b-row class="mb-3">
                    <b-col cols="12">
                      <b-input-group class="justify-content-end">
                        <b-form-input
                          textFloat=""
                          :disabled="!form.inventory_from"
                          placeholder="Search Serial"
                          type="text"
                          v-model="searchSerial"
                          @input="handlesearchSerial"
                        >
                        </b-form-input>
                        <b-input-group-append is-text class="mr-2 h-35px">
                          <b-iconstack
                            font-scale="2"
                            type="submit"
                            @click="handlesearchSerial"
                            :disabled="!form.inventory_from"
                          >
                            <b-icon
                              stacked
                              icon="search"
                              scale="0.5"
                              variant="grey"
                            ></b-icon>
                          </b-iconstack>
                        </b-input-group-append> </b-input-group
                    ></b-col>
                  </b-row>

                  <b-row
                    class="mt-2"
                    v-for="(item, index) in filteredSerial"
                    :key="`serial-move-${index}`"
                  >
                    <b-col cols="1" class=""
                      ><div class="d-flex justify-content-center mt-2">
                        #{{ index + 1 }}
                      </div>
                    </b-col>
                    <b-col cols="10" class="p-0">
                      <InputText
                        textFloat=""
                        :disabled="true"
                        placeholder="Serial"
                        type="text"
                        v-model="item.serial"
                      />
                    </b-col>
                    <b-col cols="1" class="">
                      <b-form-checkbox
                        class="pl-3 mt-2"
                        name=""
                        :disabled="
                          !form.inventory_from ||
                          mountingList.find(
                            (x) => x.serial === item.serial && !item.isMother
                          )
                            ? true
                            : false
                        "
                        :value="item.serial"
                        :checked="form.serial"
                        :unchecked-value="false"
                        @change="inputSerial(item.serial, 1, item)"
                      >
                      </b-form-checkbox>
                    </b-col>
                    <b-col cols="12" class="mb-2" v-if="item.isMother">
                      <b-row class="mx-2">
                        <b-col
                          cols="12"
                          v-for="(m, index_m) in item.mountingList.filter(
                            (x) => !x.isDupe
                          )"
                          :key="`mounting+${index_m}`"
                          class="f-12px mr-1 text-gray d-flex justify-content-between border-bottom border-left border-right"
                        >
                          <div class="ml-2 my-2">Serial: {{ m.serial }}</div>

                          <div class="mr-2 my-2">
                            Stock : {{ m.stock_type_name }}
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>

                  <div v-if="$v.form.serial.$error" class="text-error">
                    Please Select Serial
                  </div>
                </div>
              </div>

              <InputText
                v-else
                textFloat="จำนวน"
                placeholder="จำนวน"
                isRequired
                type="number"
                name="Amount"
                v-model="form.amount"
                @input="handleAmoutInput"
                :isValidate="$v.form.amount.$error"
                :disabled="form.inventory_from === 0"
                :v="$v.form.amount"
              />

              <InputText
                v-model="form.available"
                textFloat="คงเหลือ"
                :textDesc="`จำนวนปัจจุบัน : ${form.stock_from}`"
                type="number"
                name="transfer_avilable"
                className="mb-2 mt-2"
                disabled
              />

              <InputSelect
                placeholder="คลังปลายทาง"
                :validateText="`กรุณาเลือกคลัง`"
                title="คลังปลายทาง"
                v-model="form.stock_type_id"
                :isValidate="$v.form.stock_type_id.$error"
                :v="$v.form.stock_type_id"
                @onDataChange="handleInventoryFrom($event, 1)"
                valueField="id"
                :disabled="!form.inventory_from"
                textField="name"
                :options="listStockTo"
              >
                <template v-slot:option-first>
                  <b-form-select-option :value="0" disabled
                    >-- เลือกคลังปลายทาง --</b-form-select-option
                  >
                </template>
              </InputSelect>

              <InputText
                v-model="form.available_to"
                :textDesc="`จำนวนปัจจุบัน : ${form.stock}`"
                textFloat="คงเหลือ"
                type="number"
                name="transfer_avilable"
                className="mb-2"
                disabled
              />

              <InputTextArea
                :rows="4"
                textFloat="Additional Notes"
                placeholder="Additional Notes"
                id="note"
                v-model="form.note"
              /></div
          ></b-tab>
        </b-tabs>
      </div>
      <template #modal-footer="{ hide }">
        <div class="d-flex justify-content-between w-100 my-0">
          <b-button
            variant="close"
            class="btn-modal btn-hover w-50 mr-1"
            @click="hide('forget')"
          >
            ยกเลิก
          </b-button>
          <b-button
            variant="primary-color"
            class="btn-modal btn-hover w-50 ml-1"
            @click="save"
          >
            ยืนยัน
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import InputTextArea from "@/components/inputs/InputTextArea";
import { required, minValue, requiredIf } from "vuelidate/lib/validators";
const minAmount = (value, form) => {
  return (!form.is_serial && value > 0) || form.is_serial;
};
const minInventoryForm = (value, form, tabIndex) => {
  return !(((form.is_serial && tabIndex == 2) || tabIndex == 3) && value == 0);
};
export default {
  components: {
    InputText,
    InputSelect,
    InputTextArea,
  },
  props: {
    branchId: {
      required: true,
      type: [String, Number],
    },
    stock_id: { required: false, default: 0 },
  },
  data() {
    return {
      isLoading: false,
      showModal: false,

      form: {
        amount: "",
        available: 0,
        avilable: 0,
        note: "",
        currentStock: 0,
        stock: 0,
        is_serial: 0,
        serial: [],
        stock_type_id: 0,
        available_to: 0,
        inventory_from: 0,
        product_id: 0,
      },
      branchList: [],
      product: {
        id: 0,
        productName: "",
        inventoryId: 0,
        currentStock: 0,
        branchId: 0,
      },
      fromModal: "",
      tabIndex: 0,
      listStock: [],
      listStockTo: [],
      listActiveSerial: [],
      listSerial: [],
      filteredSerial: [],
      searchSerial: "",
      bracnchStock: "",
      stockDisabled: false,
      mountingList: [],
    };
  },
  validations() {
    return {
      form: {
        amount: {
          required: requiredIf(function (item) {
            return !item.is_serial;
          }),
          minAmount() {
            return minAmount(this.form.amount, this.form, this.tabIndex);
          },
        },
        stock_type_id: {
          minValue: minValue(1),
        },
        serial: {
          required: requiredIf(function () {
            return (
              this.form.is_serial && (this.tabIndex == 1 || this.tabIndex == 2)
            );
          }),
          $each: {
            text: {
              required: requiredIf(function () {
                return this.tabIndex == 0;
              }),
            },
          },
        },
        inventory_from: {
          minInventoryForm() {
            return minInventoryForm(
              this.form.inventory_from,
              this.form,
              this.tabIndex
            );
          },
        },
      },
    };
  },
  watch: {
    tabIndex(val) {
      this.$v.form.$reset();
      this.listSerial = [];
      this.form.stock_from = 0;

      this.filteredSerial = this.form.is_serial ? this.listSerial : [];
      this.searchSerial = "";
      this.form.amount = "";
      this.form.available = 0;
      this.form.available_to = 0;

      this.form.stock = 0;
      this.form.stock_type_id = val == 3 ? 0 : this.stock_id;
      this.form.inventory_from = val == 3 ? this.stock_id : 0;

      if (this.bracnchStock) {
        if (!this.form.is_serial || val !== 0)
          this.form.available = this.bracnchStock ? this.form.available : 0;
        else this.form.available = this.form.available + 1;
      }

      this.form.available_to = 0;
      this.form.is_serial && this.tabIndex == 0
        ? (this.form.serial = [{ text: "" }])
        : (this.form.serial = []);

      //แก้ส่วนของ stock inventory (ชั่วคราวกันพี่เจมส์เจอ)
      if (this.bracnchStock) {
        if (val == 0) {
          this.handleInventoryReceive(this.bracnchStock);
        } else if (
          (val == 2 && this.form.is_serial) ||
          (val == 3 && !this.form.is_serial)
        ) {
          this.form.inventory_from = this.bracnchStock;
          this.form.stock_type_id = 0;
          this.handleInventoryFrom(this.bracnchStock, 0);
        } else {
          this.form.inventory_from = 0;
          this.form.stock_type_id = this.bracnchStock;
          this.handleInventoryReceive(this.bracnchStock);
        }
      }
    },
  },
  methods: {
    async show(item, fromModal = "") {
      this.form = {
        amount: "",
        available: 0,
        avilable: 0,
        note: "",
        currentStock: 0,
        stock: 0,
        is_serial: 0,
        serial: [],
        stock_type_id: 0,
        available_to: 0,
        inventory_from: 0,
        product_id: 0,
      };
      this.bracnchStock = "";
      this.form.serial = item.is_serial ? [{ text: "" }] : [];
      this.product.id = item.product_id;
      this.product.productName = item.name;
      this.product.inventoryId = item.id;
      this.product.currentStock = item.stock;
      this.product.branchId = item.branch_id;
      this.form.product_id = item.product_id;
      const res = await this.axios.get(
        `${this.$baseUrl}/Inventory/GetActiveStockType/${this.branchId}/${item.product_id}`
      );

      if (res.result) {
        this.listStock = res.detail.map((x) => ({
          ...x,
          name: x.name + " (" + x.stock + ")",
          disabled: false,
        }));
        this.listStockTo = this.listStock;
      }
      this.form.is_serial = item.is_serial;
      this.$nextTick(() => {
        this.$v.$reset();
      });

      // if (item.stock_type_id && item.is_serial) {
      //   this.form.stock_type_id = item.stock_type_id;
      //   this.bracnchStock = item.stock_type_id;
      //   await this.handleInventoryReceive(item.stock_type_id);
      //   this.form.inventory_from = item.inventory_from;
      //   this.stockDisabled = true;
      // } else {
      //   this.stockDisabled = false;
      // }
      this.showModal = true;
    },

    async handleInventoryReceive(input) {
      this.form.stock_type_id = input;
      this.form.amount = "";
      this.form.inventory_id = this.listStock.find(
        (x) => x.id == input
      ).inventory_id;
      this.filteredSerial = this.form.is_serial ? this.listSerial : [];
      this.searchSerial = "";
      this.form.available =
        this.form.is_serial && this.tabIndex == 0
          ? this.listStock.find((x) => x.id == input).stock +
            this.form.serial.length
          : this.listStock.find((x) => x.id == input).stock;

      this.form.stock = this.listStock.find((x) => x.id == input).stock;
      await this.getSerialFromStock();
    },
    hide() {
      this.filteredSerial = [];
      this.mountingList = [];
      this.showModal = false;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleMaxTransfer(val) {
      if (this.tabIndex == 1)
        return parseInt(val) <= parseInt(this.product.currentStock);
      return true;
    },
    async validateSerial() {
      const res = await this.axios.post(
        `${this.$baseUrl}/Inventory/UpdateInventory/validate/serial`,
        {
          ...this.form,
          amount: this.form.amount || 0,
          serial: this.form.serial.map((item) => item.text),
        }
      );
      if (!res.detail.result) {
        this.errorAlert(res.detail.message);
        return false;
      }
      return true;
    },
    async save() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      this.isLoading = true;

      let edit_type = this.tabIndex + 1;
      if ((this.form.is_serial && this.tabIndex == 2) || this.tabIndex == 3) {
        edit_type = 9;
      }

      let body = {
        edit_type: edit_type,
        ...this.form,
        amount: this.form.amount || 0,
        branch_id: this.branchId,
        to_branch_id: 0,
      };
      //Check Serial
      if (this.form.is_serial && edit_type == 1) {
        const serialList = this.form.serial.map((item) => item.text);
        const hasDuplicates = serialList.some(
          (text, index) => serialList.indexOf(text) !== index
        );
        if (hasDuplicates) {
          this.errorAlert("Duplicate serial number");

          return;
        } else {
          let validate = await this.validateSerial();
          if (!validate) {
            return;
          }
        }
      }

      await this.$store.dispatch("setMainLoading", true);

      if (this.mountingList.length) {
        this.mountingList = this.mountingList.map((x) => ({
          inventory_id: this.form.inventory_id,
          branch_id: this.branchId,
          product_id: x.product_id,
          stock: this.form.stock,
          inventory_from: x.stock_type_id,
          stock_from: this.form.stock_from,
          amount: this.form.amount || 0,
          edit_type: 9,
          note: this.form.note,
          available: this.form.available,
          is_serial: 1,
          serial: [x.serial],
          stock_type_id: this.form.stock_type_id,
          available_to: this.form.available_to,
          to_branch_id: 0,
        }));
        const existingSerials = this.mountingList.flatMap(
          (item) => item.serial
        );
        let other = this.form.serial
          .filter((y) => !existingSerials.includes(y))
          .map((x) => ({
            inventory_id: this.form.inventory_id,
            branch_id: this.branchId,
            product_id: this.filteredSerial.find((s) => s.serial == x)
              .product_id,
            stock: this.form.stock,
            inventory_from: this.form.inventory_from,
            stock_from: this.form.stock_from,
            amount: this.form.amount || 0,
            edit_type: 9,
            note: this.form.note,
            available: this.form.available,
            is_serial: 1,
            serial: [x],
            stock_type_id: this.form.stock_type_id,
            available_to: this.form.available_to,
            to_branch_id: 0,
          }));

        this.mountingList.push(...other);

        const response = await this.axios.post(
          `${this.$baseUrl}/inventory/UpdateInventory/mounting`,

          this.mountingList
        );

        if (response.result) {
          this.successAlert();
          this.hide();
        } else this.errorAlert(response.message);
        this.$emit("reloadDataTable");
        await this.$store.dispatch("setMainLoading", false);
        return;
      }

      await this.axios
        .post(`${this.$baseUrl}/Inventory/UpdateInventory`, {
          ...body,
          serial:
            edit_type == 1
              ? this.form.serial.map((item) => item.text)
              : this.form.serial,
        })
        .then(async (data) => {
          await this.$store.dispatch("setMainLoading", false);
          if (data.result == 1) {
            this.successAlert();
            this.$emit("reloadDataTable");
            this.hide();
          } else {
            this.errorAlert("Duplicate serial number");
          }
        });
      this.isLoading = false;
    },
    handleAmoutInput(value, $event) {
      if (this.tabIndex == 1 || this.tabIndex == 3) {
        let stock = this.tabIndex == 3 ? this.form.stock_from : this.form.stock;

        if (stock < this.form.amount) {
          return this.$nextTick(() => {
            $event.preventDefault();

            this.form.amount = Number(stock);
            this.form.available = 0;
            return ($event.target.value = Number(stock));
          });
        }
      }
      if (this.tabIndex == 0) {
        let amount = this.form.amount ? this.form.amount : 0;
        this.form.available = Number(amount) + Number(this.form.stock);
      } else if (
        this.tabIndex == 3 ||
        (this.form.is_serial && this.tabIndex == 2)
      ) {
        let amount = this.form.amount ? this.form.amount : 0;
        this.form.available = Number(this.form.stock_from) - Number(amount);
        this.form.available_to = this.form.stock_type_id
          ? Number(this.form.stock) + Number(amount)
          : 0;
      } else {
        let amount = this.form.amount ? this.form.amount : 0;
        this.form.available = Number(this.form.stock) - Number(amount);
      }
    },
    async inputSerial(serial, isMove) {
      const isAlreadySelected = this.form.serial.includes(serial);
      const item = this.filteredSerial.find((x) => x.serial === serial);

      if (!item) return;

      if (isAlreadySelected) {
        this.form.serial = this.form.serial.filter((s) => s !== serial);
        this.form.available += 1;

        if (item.isMother) {
          const mountedInFiltered = item.mountingList.filter((child) =>
            this.filteredSerial.some((f) => f.serial === child.serial)
          );

          const mountedCount = mountedInFiltered.length;

          if (isMove && this.form.stock_type_id) {
            const filteredStock =
              item.mountingList.filter(
                (x) => x.stock_type_id !== this.form.stock_type_id
              ).length + 1 || 1;
            this.form.available_to -= filteredStock;
          }

          this.form.available += mountedCount;

          this.form.serial = this.form.serial.filter(
            (s) =>
              s !== item.serial &&
              !item.mountingList.some((m) => m.serial === s)
          );

          this.mountingList = this.mountingList.filter(
            (m) => !item.mountingList.some((child) => child.serial === m.serial)
          );

          item.mountingList = [];
          item.isMother = false;

          return;
        }

        if (isMove && this.form.stock_type_id) {
          this.form.available_to -= 1;
        }
      } else {
        if (!this.form.stock_type_id) {
          this.warningAlert("กรุณาเลือกคลังปลายทาง!");
          this.form.serial.push(serial);
          this.form.serial = this.form.serial.filter((s) => s !== serial); //ต้องทำแบบนี้ไม่อย่างนั้นตัว Checkbox จะถูกติ๊ก
          return;
        }
        this.form.serial.push(serial);

        if (serial) {
          const res = await this.axios(
            `${this.$baseUrl}/product/product_serial_mounting/${this.branchId}/${this.form.product_id}/${serial}`
          );

          const mountingList = res.detail;

          if (mountingList.length) {
            const serialsToAdd = mountingList.map((x) => x.serial);
            this.form.serial.push(...serialsToAdd);

            item.mountingList = mountingList.map((x) => ({
              ...x,
              isDupe: this.filteredSerial.some((y) => y.serial === x.serial),
            }));

            this.mountingList.push(...mountingList);

            const mother = this.filteredSerial.find((x) => x.serial === serial);
            if (mother) mother.isMother = true;
            item.isMother = true;

            const mountedInFiltered = item.mountingList.filter((child) =>
              this.filteredSerial.some((f) => f.serial === child.serial)
            );

            const mountedCount = mountedInFiltered.length;

            this.form.available -= 1 + mountedCount;

            if (this.form.stock_type_id) {
              const filteredStock =
                item.mountingList.filter(
                  (x) => x.stock_type_id !== this.form.stock_type_id
                ).length + 1 || 1;
              this.form.available_to += filteredStock;
            }

            return;
          }
        }

        this.form.available -= 1;

        if (isMove && this.form.stock_type_id) {
          this.form.available_to += 1;
        }
      }
    },

    handlesearchSerial(val) {
      this.filteredSerial = this.listSerial.filter((x) =>
        x.serial.toLowerCase().includes(val.toLowerCase())
      );
    },
    addSerial() {
      this.form.serial.push({ text: "" });
      if (!this.form.stock_type_id && !this.form.inventory_from) {
        return;
      } else {
        this.form.available += 1;
      }
    },
    deleteSerial(index) {
      if (index == 0) {
        return;
      } else {
        this.form.serial.splice(index, 1);
        this.form.available -= 1;
      }
    },
    async handleInventoryFrom(input, isToStock) {
      if (!isToStock) {
        this.form.inventory_from = input;
        this.listStockTo = this.listStock.map((x) => ({
          ...x,
          disabled: false,
        }));
        //Clear stock to
        this.form.stock_type_id = 0;
        this.form.available_to = 0;
        this.form.stock = 0;

        //Clear stock to
        this.form.amount = "";
        this.form.stock_from = this.listStock.find((x) => x.id == input).stock;
        this.form.available = this.listStock.find((x) => x.id == input).stock;

        const stockToItem = this.listStockTo.find((x) => x.id == input);
        if (stockToItem) {
          stockToItem.disabled = true;
        }
        await this.getSerialFromStock();
      } else {
        this.form.stock_type_id = input;
        let stockToItem = this.listStockTo.find((x) => x.id == input);
        this.form.available_to = this.form.is_serial
          ? stockToItem.stock + this.form.serial.length
          : stockToItem.stock + this.form.amount;
        this.form.stock = this.listStock.find((x) => x.id == input).stock;

        this.form.inventory_id = this.listStockTo.find(
          (x) => x.id == input
        ).inventory_id;
      }
    },
    async getSerialFromStock() {
      if (this.form.is_serial) {
        const responseSerial = await this.axios.get(
          `${this.$baseUrl}/Inventory/GetInventorySerial/${this.branchId}/${
            this.product.id
          }/${this.form.stock_type_id || this.form.inventory_from}`
        );
        this.listSerial = responseSerial.detail;
        this.filteredSerial = responseSerial.detail;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  color: #fff;
  width: 100%;
  background-color: var(--primary-color);
}
::v-deep .modal-body {
  padding: 1rem 1rem;
}
.btn-primary .modal-body {
  margin: auto;
  text-align: center;
}
::v-deep .nav-tabs li:nth-child(2) {
  border-left: 1px solid white;
  border-right: 1px solid white;
}

.icon-size {
  width: 15px;
  height: 15px;
}

.h-35px {
  height: 35px;
}

.maxheight-290px {
  max-height: 290px !important;
  overflow: auto;
}
</style>
